import React, { useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import CropFreeIcon from "@mui/icons-material/CropFree";

import BigButton from "../BigButton";
import ScanditScanner from "./ScanditScanner/ScanditScanner";

const ScannerFields = ({ onChange, barcode, error, disabled, name }) => {
  const [scanOpened, setScanOpened] = useState(false);
  const handleToggle = () => setScanOpened(v => !v);

  if (scanOpened) {
    return <ScanditScanner onDetected={onChange} onClose={handleToggle} />;
  }

  return (
    <FormControl fullWidth>
      <Box mb={2}>
        <BigButton disabled={disabled} onClick={handleToggle}>
          <CropFreeIcon fontSize="large" />
        </BigButton>

        <Box mb={2}></Box>

        <FormControl fullWidth>
          <TextField
            disabled={disabled}
            name={name || "barcode"}
            label="Barcode"
            inputProps={{ autoComplete: "off" }}
            value={barcode || ""}
            onChange={event => onChange(event.target.value)}
            variant="outlined"
          />

          {error && (
            <Box mt={1}>
              <FormHelperText htmlFor="barcode" error={!!error}>
                {error}
              </FormHelperText>
            </Box>
          )}
        </FormControl>
      </Box>
    </FormControl>
  );
};

export default ScannerFields;
